import React, {ReactElement, useLayoutEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {IShape} from '../../../../../incase-domain/elements/question/imageMarkup';
import {DEBATABLE_ANSWER_COLOR} from '../../../../../incase-domain/common/color';
import {JS_INTERACTABLE_ELEMENT} from '../../../../../constants';
import {toLocalPoint} from '../../../../../util/domScale';

interface ImageMarkupClickCanvasProps {
    width: number;
    height: number;
    onClick: (shape: IShape[]) => void;
    clickAnswers: IShape[];
    answered: boolean;
    isDebatable: boolean;
}

function ImageMarkupClickCanvas(props: ImageMarkupClickCanvasProps): ReactElement {
    const {width, height, onClick, clickAnswers, answered, isDebatable} = props;

    const {t} = useTranslation();

    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const canvas = canvasRef.current;

    useLayoutEffect(() => {
        if (canvas && clickAnswers) {
            const ctx = canvas.getContext('2d');
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                // eslint-disable-next-line no-nested-ternary

                ctx.lineWidth = 2;

                clickAnswers.forEach((point) => {
                    const {x, y} = point.points[0];
                    // eslint-disable-next-line no-nested-ternary
                    if (!isDebatable) ctx.strokeStyle = point.isCorrect === undefined ? 'blue' : point.isCorrect ? 'green' : 'red';
                    else ctx.strokeStyle = point.isCorrect === undefined ? 'blue' : DEBATABLE_ANSWER_COLOR;
                    ctx.beginPath();
                    ctx.moveTo(x * canvas.width, y * canvas.height - 10);
                    ctx.lineTo(x * canvas.width, y * canvas.height + 10);
                    ctx.stroke();

                    ctx.beginPath();
                    ctx.moveTo(x * canvas.width - 10, y * canvas.height);
                    ctx.lineTo(x * canvas.width + 10, y * canvas.height);
                    ctx.stroke();
                });
            }
        }
    }, [canvas, width, height, clickAnswers, clickAnswers.length, answered, isDebatable]);

    const handleClick = (e: React.MouseEvent<HTMLCanvasElement>): void => {
        if (canvas && !answered) {
            const {x, y} = toLocalPoint(canvas, e.clientX, e.clientY, 1, 1);

            onClick([...clickAnswers, {points: [{x, y}]}]);
        }
    };

    const handleClear = (): void => {
        onClick([]);
    };

    return (
        <>
            <canvas
                className={`c-imageMarkup__canvas ${!answered ? 'c-imageMarkup__canvas--crosshair' : ''} ${JS_INTERACTABLE_ELEMENT}`}
                width={width}
                height={height}
                ref={canvasRef}
                onClick={handleClick}
            />
            {!answered && clickAnswers.length > 0 && (
                <button type="button" onClick={handleClear}>
                    {t('common.clear')}
                </button>
            )}
        </>
    );
}

export default ImageMarkupClickCanvas;
